import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import ms from 'ms';

import { queryKeysAi } from '../queryKeys';

import { fetchMappingsFields } from './fetchMappingsFields';
import { type MappingsFieldsResponse } from './types';

/**
 * Custom useQuery hook to fetch all available Document Intelligence field names.
 * Reads the di_mapping section from mappings.json and extracts all unique field names.
 * @param options - Query options.
 * @returns The list of available field names and their count.
 * @see https://fa-vestigas-dev.azurewebsites.net/docs#/Metadata/get_mappings_fields_get_mappings_fields_get
 */
export const useQueryMappingsFields = <TData = MappingsFieldsResponse>(
  options?: Omit<
    UseQueryOptions<MappingsFieldsResponse, Error, TData>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery<MappingsFieldsResponse, Error, TData>({
    queryFn: async ({ signal }) => fetchMappingsFields({ signal }),
    queryKey: queryKeysAi.getMappingsFields(),
    staleTime: ms('24h'),
    ...options,
  });
